import React, { useCallback, useEffect, useState } from 'react';
import useAdminFetchApi from '../../utils/adminFetchApi';

export default function AdminChannels() {
  const api = useAdminFetchApi();
  const [channels, setChannels] = useState([]);
  const [withStats, setWithStats] = useState(true);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const fetchChannels = useCallback(async () => {
    setLoading(true);
    setError('');
    try {
      const endpoint = withStats ? '/admin/channels?includeStats=true' : '/admin/channels';
      const data = await api.get(endpoint);
      const list = Array.isArray(data) ? data : (data?.channels || []);
      setChannels(list);
    } catch (e) {
      setError(e.message || 'Failed to load channels');
    } finally {
      setLoading(false);
    }
  }, [api, withStats]);

  useEffect(() => { fetchChannels(); }, [fetchChannels]);

  return (
    <div className="admin-section">
      <div className="admin-toolbar">
        <label style={{display:'flex', alignItems:'center', gap:8}}>
          <input type="checkbox" checked={withStats} onChange={(e)=>setWithStats(e.target.checked)} /> Include stats
        </label>
        <div className="spacer" />
  <button onClick={fetchChannels} className="submit-button" style={{width:'auto'}}>Refresh</button>
      </div>
      {error && <div className="error-message" style={{marginBottom:12}}>{error}</div>}
      {loading ? (
        <div className="loading-row">Loading channels…</div>
      ) : (
        <div className="table-wrap">
          <table className="admin-table">
            <thead>
              <tr>
                <th>id</th>
                <th>name</th>
                <th>label</th>
                <th>country</th>
                <th>stats</th>
              </tr>
            </thead>
            <tbody>
              {channels.length === 0 ? (
                <tr><td colSpan={5} style={{textAlign:'center', color:'#94a3b8'}}>No channels</td></tr>
              ) : channels.map((c, idx) => (
                <tr key={c.id || c.key || c.name || idx}>
                  <td>{c.id ?? c.key ?? ''}</td>
                  <td>{c.name ?? ''}</td>
                  <td>{c.label ?? ''}</td>
                  <td>{c.country ?? ''}</td>
                  <td>
                    {c.stats ? (
                      <span>
                        public: {c.stats.public ?? 0} · private: {c.stats.private ?? 0} · total: {c.stats.total ?? (c.stats.public ?? 0) + (c.stats.private ?? 0)}
                      </span>
                    ) : '—'}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
